<template>
  <div class="task-addItem">
    <div class="steps">
      <div class="title">
        <i class="icon icon-caidangongneng"></i>
        <span v-if="!edit">{{ $t('dms_firmwareTask_addItem.tian_jia_ren_wu') }}</span>
        <span v-else>{{ $t('dms_firmwareTask_addItem.bian_ji_ren_wu') }}</span>
      </div>
      <t-step v-model="tabActive" :list="stepList" @change="changeStep"></t-step>
    </div>
    <div class="warpper">
      <!--任务信息-->
      <firmwareTask-info v-if="tabActive === 1" :taskId="taskId" @success="saveInfo" @changeServiceType="changeServiceType" @previous="previous" @syncTopicId="syncTopicId"></firmwareTask-info>
      <!--如果是serviceType==='3'升级固件  选择固件-->
      <firmware-version
        v-if="tabActive === 2 && serviceType === '3'"
        :taskId="taskId"
        :resourceId="resourceId"
        :data="infoForm"
        @success="nextStep"
        @changeresourceId="changeresourceId"
        @previous="previous"
      ></firmware-version>
      <!--如果是serviceType!=='3'非升级固件就录入指令-->
      <!-- && topicCode!=='configBill' -->
      <!-- commandMode -->
      <firmwareTask-instruction
        v-if="tabActive === 2 && serviceType !== '3' && `${commandMode}` !== '5'"
        :taskId="taskId"
        :data="infoForm"
        @success="nextStep"
        @previous="previous"
      ></firmwareTask-instruction>
      <!--configBill 账单配置 -->
      <!-- && topicCode==='configBill' -->
      <firmwareTask-configBill
        v-if="tabActive === 2 && serviceType !== '3' && `${commandMode}` === '5'"
        :taskId="taskId"
        :resourceId="resourceId"
        :data="infoForm"
        @success="nextStep"
        @previous="previous"
      ></firmwareTask-configBill>
      <!-- 如果是升级固件的话 第三步要用到第二步绑定的固件id -->
      <select-device v-if="tabActive === 3" :data="infoForm" :taskId="taskId" :resourceId="resourceId" @success="nextStep" @previous="previous"></select-device>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import firmwareTaskInfo from './firmwareTask_info.vue';
// import firmwareTaskInfo from './firmwareTask_info_copy.vue';

// 录入指令
import firmwareTaskInstruction from './firmwareTask_instruction';
import firmwareTaskConfigBill from './firmwareTask_configBill';
import firmwareVersion from './firmwareTask_version';
import selectDevice from './firmwareTask_select_device';

export default {
  name: 'firmwareTask_item',
  components: { firmwareTaskInfo, firmwareVersion, selectDevice, tStep, firmwareTaskInstruction, firmwareTaskConfigBill },
  data() {
    return {
      provide: true,
      visible: false,
      normalItemList: [],
      tabActive: 1,

      taskId: '',
      serviceType: '',
      commandMode: '', // commandMode  1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择
      topicCode: '',
      edit: false,
      // 第一步的数据用来共享
      infoForm: {},
      productList: [],
      // 第二步

      // 第二步固件id
      resourceId: '',

      isLoadingVersion: false,
      versionList: [],
      totalRowsVersion: null,
      versionListSelect: [],
      tableColumnVersion: null,
    };
  },
  computed: {
    stepList() {
      return [
        {
          label: 1,
          value: 1,
          title: this.$t('dms_firmwareTask_addItem.ren_wu_xin_xi'),
          subTitle: this.$t('dms_firmwareTask_addItem.txrwxx'),
        },
        {
          label: 2,
          value: 2,
          title: this.$t('dms_firmwareTask_addItem.lu_ru_zhi_ling'),
          subTitle: this.$t('dms_firmwareTask_addItem.lrrwzl'),
        },
        {
          label: 3,
          value: 3,
          title: this.$t('dms_firmwareTask_addItem.xuan_ze_she_bei'),
          subTitle: this.$t('dms_firmwareTask_addItem.xzrwsb'),
        },
      ];
    },
  },
  mounted() {


    if (this.$route.path.indexOf('edit') > -1) {
      this.edit = true;
      // 获取id   有去获取详情 无就新增
      this.taskId = this.getJump('taskId');
      this.getTaskInfo();
    }
    // 清除缓存
    // this.clearKeepAlive('firmwareTask');
  },
  methods: {
    // 初始化
    nextStep: function (num) {
      this.tabActive = num;
      // if (num === 3) {
      //   this.tabActive = 3;
      // }
      this.clearKeepAlive('firmwareTask');
    },
    previous: function () {
      this.tabActive = --this.tabActive;
    },
    // 编辑的时候点击步骤
    changeStep: function (arg) {
      if (this.edit) {
        this.tabActive = arg.value;
      }
    },
    // 第一步修改任务类型
    changeServiceType() {
      // 不区分固件还是其他指令，都用这个名称
      // this.stepList[1].title = '录入指令';
      // this.stepList[1].subTitle = '录入任务指令';
    },
    // 第二步修改固件版本
    changeresourceId: function (resourceId) {
      this.resourceId = resourceId;
    },
    // 获取固件信息
    getTaskInfo: function () {
      this.$getJSON(`${apis.commandTaskDevice}/${this.taskId}`).then((res) => {
        this.serviceType = `${res.data.serviceType}`;
        // 只有固件升级才有固件id
        if (this.serviceType === '3') {
          // 第二步固件id
          this.resourceId = res.data.resourceId || '';
        }
      });
    },

    getSteps1: function () {
      // 第一步选择合同
      // this.getproductList();
    },
    saveInfo: function (taskId, serviceType, commandMode, infoForm) {
      this.taskId = taskId;
      // 任务类型
      this.serviceType = serviceType;
      this.commandMode = commandMode;
      this.topicCode = infoForm.topicCode || '';
      // 第一步表单值 用于后面共享值
      this.infoForm = infoForm;
      this.tabActive++;
    },
    syncTopicId: function (taskId, serviceType, commandMode, infoForm) {
      this.taskId = taskId;
      // 任务类型
      this.serviceType = serviceType;
      this.commandMode = commandMode;
      this.topicCode = infoForm.topicCode || '';
      // 第一步表单值 用于后面共享值
      this.infoForm = infoForm;
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.task-addItem {
  // display: flex;
  // height: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  .steps {
    // height: 100%;
    // width: 220px;
    // background: #f9f9fd;
    position: absolute;
    left: 0;
    top: 0;
    width: 220px;
    bottom: 0;
    background-color: #f9f9fd;
    .title {
      height: 70px;
      line-height: 70px;
      padding-left: 18px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(57, 70, 104, 1);
      .icon {
        color: #0d9ae0;
        // color: $main-color;
        font-size: 13px;
        margin-right: 10px;
      }
    }
  }
  .warpper {
    // flex: 1;
    // height: 100%;
    // background-color: #ffffff;
    background-color: #ffffff;
    margin-left: 220px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .content-box {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      }
      .btn-group {
        border-top: 1px solid #eef2f8;
        padding: 16px 0 16px 24px;
        height: 60px;
        z-index: 1;
        -webkit-box-flex: 0;
        flex: 0 0 60px;
      }
    }
  }
}
// 步骤条
.steps {
  display: flex;
  flex: 0 0 220px;
  padding: 20px 0;
  overflow: hidden;
  flex-direction: column;
  .steps-item {
    flex: 1;
    .steps-item-head {
      position: relative;
      width: 100%;
      color: #8c8c8c;
      border-color: #8c8c8c;
      text-align: center;
      .line {
        position: relative;
        border-color: inherit;
        background-color: #d3d3d3;
        width: 100%;
        .line-left {
          left: 0;
          // right: -50%;
          height: 2px;
          top: 11px;
          position: absolute;
          border-color: inherit;
          background-color: #d3d3d3;
          background-color: inherit;
          width: 50%;
        }
        .line-rigth {
          // left: 50%;
          left: 50%;
          height: 2px;
          top: 11px;
          position: absolute;
          border-color: inherit;
          background-color: #d3d3d3;
          background-color: inherit;
          width: 50%;
        }
      }
      .icon {
        position: relative;
        z-index: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        background: #eff0f3;
        transition: 0.15s ease-out;
        border-radius: 50%;
        border: 1px solid;
        border-color: inherit;
        color: #999;
      }
    }
    .steps-item-main {
      text-align: center;
      .title {
        margin-top: 15px;
        color: #999;
      }
    }
  }
  .steps-item.on {
    flex: 1;
    .steps-item-head {
      color: #00afff;
      border-color: #00afff;
      .line {
        background-color: #00afff;
      }
      .icon {
        background: #00afff;
        color: #fff;
      }
    }
    .steps-item-main {
      text-align: center;
      .title {
        margin-top: 15px;
        color: #999;
      }
    }
  }

  .steps-item:first-of-type {
    .line {
      .line-left {
        display: none;
      }
    }
  }
  .steps-item:last-of-type {
    .line {
      .line-rigth {
        display: none;
      }
    }
  }
}
</style>
